import { connect } from 'react-redux';

import SearchPage from 'components/SearchPage';
import { TYPES } from 'constants/topNavigation';
import * as actions from 'state/actions';
import Rudderstack from 'utils/Rudderstack';

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
  };
};

const mapDispatchToProps = dispatch => ({
  trackSearchNavigation: url => {
    dispatch(actions.trackSearchNavigation(url));

    Rudderstack.navigationClicked({
      navigationType: TYPES.SEARCH,
      navigationSource: url,
    });

    // Because this function will be added to an <a> tag's onClick handler, it needs to return true to not prevent navigation
    return true;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);
